import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Cross from 'yoda-core-components/lib/assets/svg/Cross.svg';
import MailFill from 'yoda-core-components/lib/assets/svg/MailFill.svg';
import Phone from 'yoda-core-components/lib/assets/svg/Phone.svg';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './MarketingOptInSection.css';

const cx = classNames.bind(styles);

const inputTypes = ['email', 'tel', 'number', 'text'];

export default class MarketingOptInSection extends Component {
    /**
     * Supported React properties
     * @type {Object}
     * buttonType can be anyone of BUTTON_TYPES from <Button> Component
     */
    static defaultProps = {
        type: '',
        placeholder: '',
        buttonType: '',
        children: '',
        customClass: '',
        customInputClass: '',
        customInputWrapperClass: '',
        customInputWithIconClass: '',
        submitCallback: null,
        onChangeCallback: null,
        refCallback: null,
        defaultValue: '',
        btnDataId: '',
        automationId: '',
        buttonClass: '',
        showInputPhoneIcon: false,
        showInputEmailIcon: false,
        formattedPhoneNum: '',
        buttonWrap: '',
        handleClearInputVal: null,
        isSuccess: false,
    };

    static propTypes = {
        type: PropTypes.oneOf(inputTypes),
        placeholder: PropTypes.string,
        buttonType: PropTypes.string,
        children: PropTypes.string,
        customClass: PropTypes.string,
        customInputClass: PropTypes.string,
        customInputWrapperClass: PropTypes.string,
        customInputWithIconClass: PropTypes.string,
        btnDataId: PropTypes.string,
        submitCallback: PropTypes.func,
        handleClearInputVal: PropTypes.func,
        onChangeCallback: PropTypes.func,
        refCallback: PropTypes.func,
        defaultValue: PropTypes.string,
        buttonClass: PropTypes.string,
        formattedPhoneNum: PropTypes.string,
        buttonWrap: PropTypes.string,
        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */
        automationId: PropTypes.string,
        showInputPhoneIcon: PropTypes.bool,
        showInputEmailIcon: PropTypes.bool,
        isSuccess: PropTypes.bool, // eslint-disable-line
    };

    constructor() {
        super();
        this.submitForm = this.submitForm.bind(this);
        this.valueChanged = this.valueChanged.bind(this);

        this.state = {
            value: '',
            displayCrossBar: false,
            crossBarFocused: false,
            setFormattedNum: '',
            formSubmit: false,
        };
    }

    /* istanbul ignore next */
    componentWillMount() {
        /* istanbul ignore next */
        if (this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    /* istanbul ignore next */
    componentDidMount() {
        /* istanbul ignore next */
        this.unmount = getBrowserHistory().listen(() => {
            if (this.state.value) {
                this.setState({ value: '' });
                this.setState({ setFormattedNum: '' });
            }
        });
    }

    /* istanbul ignore next */
    componentWillReceiveProps(nextProps) {
        /* istanbul ignore next */
        if (!this.props.defaultValue && nextProps.defaultValue) {
            this.setState({ value: nextProps.defaultValue });
        }
        if (nextProps.isSuccess && this.state.formSubmit) {
            this.setState({ formSubmit: false });
            this.clearSearch();
        }
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        if (this.unmount) {
            this.unmount();
        }
    }

    onCorssBarFocused = (currentState) => {
        this.setState({ crossBarFocused: currentState });
    };

    unmount = null;

    toggleCrossBar = (currentState) => {
        const { crossBarFocused } = this.state;
        if (!crossBarFocused) {
            this.setState({ displayCrossBar: currentState });
        }
    };

    clearSearch = () => {
        this.setState({ value: '' });
        /* istanbul ignore next */
        if (this.props.handleClearInputVal) {
            this.props.handleClearInputVal();
        }
    };

    valueChanged(event) {
        this.setState({ value: event.target.value });
        this.setState({ setFormattedNum: this.props.formattedPhoneNum });
        if (this.props.onChangeCallback) {
            this.props.onChangeCallback(event.target.value);
        }
    }

    submitForm(event) {
        if (this.props.submitCallback) {
            this.props.submitCallback();
            this.setState({
                formSubmit: true,
            });
        }

        event.preventDefault();
    }
    /**
     * Renders the basic outer skeleton required to render the MarketingOptInSection
     * @return {ReactComponent}
     */

    render() {
        const {
            btnDataId,
            buttonType,
            buttonClass,
            customClass,
            children,
            automationId,
            buttonWrap,
            type,
            placeholder,
            customInputClass,
            customInputWrapperClass,
            customInputWithIconClass,
            refCallback,
        } = this.props;

        const { value, displayCrossBar, crossBarFocused } = this.state;
        const marketingOptInSectionStyle = dt(['my-0', 'mx-auto', 'sm:max-w-[327px]', 'table']);
        const inputWrapperStyle = dt(['table-cell', 'w-full', 'relative']);
        const crossBarStyle = dt(['absolute', 'right-3', 'top-0', 'h-full', 'py-0']);
        const closeIconStyle = dt(['fill-gray-60', 'text-link-hover']);
        const marketingOptInInputStyle = dt([
            'py-1',
            'pr-10',
            'pl-5',
            'w-full',
            'box-border',
            'h-12',
            'border',
            'border-solid',
            'border-gray-60',
            'text-small',
            'focus:outline-none',
        ]);
        const buttonWrapperStyle = dt(['table-cell', 'align-top']);
        const marketingOptInBtnStyle = dt([
            'w-20',
            'box-border',
            'rounded-r',
            'sm:!rounded-l-none',
            'pt-2',
            'pb-2.5',
            'px-2.5',
            'text-small',
            'cursor-pointer',
            'sm:!bg-brand-red',
        ]);
        return (
            <form onSubmit={this.submitForm}>
                <div
                    className={cx('marketingOptInSection', customClass, marketingOptInSectionStyle)}
                    data-automation-id={automationId}
                >
                    <div
                        className={cx(
                            styles.inputWrapper,
                            inputWrapperStyle,
                            customInputWrapperClass
                        )}
                    >
                        <div
                            className={`${dt(['relative'])} ${cx(
                                styles.inputwithIcon,
                                customInputWithIconClass
                            )}`}
                        >
                            <input
                                className={cx(
                                    'marketingOptInInput',
                                    marketingOptInInputStyle,
                                    customInputClass
                                )}
                                data-automation-id="marketing-input"
                                data-tl-private="true" // updated to lowercase to fix this warning - MNPDPYODA-10602-React does not recognize the `data-tlPrivate` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `data-tlprivate` instead
                                data-cs-mask="true"
                                type={type}
                                ref={refCallback}
                                placeholder={placeholder}
                                aria-required="true"
                                value={
                                    this.props.formattedPhoneNum
                                        ? this.props.formattedPhoneNum
                                        : this.state.value
                                }
                                onFocus={() => this.toggleCrossBar(true)}
                                onBlur={() => this.toggleCrossBar(false)}
                                onChange={this.valueChanged}
                            />
                        </div>
                        {value.length && (displayCrossBar || crossBarFocused) ? (
                            <button
                                id="input-cross-icon"
                                className={`${styles.crossBar} ${crossBarStyle}`}
                                onClick={this.clearSearch}
                                type="button"
                                onMouseEnter={() => this.onCorssBarFocused(true)}
                                onMouseLeave={() => this.onCorssBarFocused(false)}
                            >
                                <Icon
                                    iconType="svg"
                                    className="arrow-icon"
                                    width="18.6px"
                                    height="18.6px"
                                    viewBox="0 0 20 20"
                                    pathClassName={`${styles.closeIcon} ${closeIconStyle}`}
                                >
                                    <Cross />
                                </Icon>
                            </button>
                        ) : (
                            ''
                        )}
                    </div>

                    <div className={cx(styles.buttonWrapper, buttonWrapperStyle, buttonWrap)}>
                        <Button
                            btnDataId={btnDataId}
                            type="button"
                            buttonType={buttonType}
                            automationId="marketing-button"
                            className={cx('marketingOptInBtn', marketingOptInBtnStyle, buttonClass)}
                            onClick={this.submitForm}
                        >
                            {children}
                        </Button>
                    </div>
                </div>
            </form>
        );
    }
}
